import { TextField } from '@refinedev/antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Reception } from '@/model/Logistic/Reception/Reception';
import { Country, phoneNumberMeta } from '@/utils/phoneNumbers';

interface ReceptionShowReturnAddressProps {
  record?: Reception;
}

const ReceptionShowReturnAddress = (props: ReceptionShowReturnAddressProps) => {
  const { t } = useTranslation();
  const { record } = props;
  const countryCode = useMemo(() => {
    return Country[record?.receiver_localidad?.provincia?.pais?.id];
  }, [record]);

  return (
    <div className="ReceptionShowDataCard">
      <div className="ReceptionShowData">
        <b>{t('Operador logístico de retorno')}</b>
        <TextField value={record?.return_shipper?.name} />
      </div>
      <div className="ReceptionShowData">
        <b>{t('País')}</b>
        <TextField value={record?.receiver_localidad?.provincia?.pais?.nombre} />
      </div>
      <div className="ReceptionShowData">
        <b>{t('Provincia')}</b>
        <TextField value={record?.receiver_localidad?.provincia?.nombre} />
      </div>
      <div className="ReceptionShowData">
        <b>{t('Localidad')}</b>
        <TextField value={record?.receiver_localidad?.nombre} />
      </div>
      <div className="ReceptionShowData">
        <b>{t('Código postal')}</b>
        <TextField value={record?.receiver_postal_code ? record?.receiver_postal_code : '-'} />
      </div>
      <div className="ReceptionShowData">
        <b>{t('Dirección')}</b>
        <TextField value={record?.receiver_address ? record?.receiver_address : '-'} />
      </div>
      <div className="ReceptionShowData">
        <b>{t('Email')}</b>
        <TextField value={record?.receiver_email ? record?.receiver_email : '-'} />
      </div>
      <div className="ReceptionShowData">
        <b>{t('Número de teléfono')}</b>
        <TextField
          value={
            record?.receiver_phone && countryCode
              ? `${phoneNumberMeta[countryCode].phoneCountry} ${record?.receiver_phone}`
              : '-'
          }
        />
      </div>
      <div className="ReceptionShowData">
        <b>{t('Nombre y apellido del destinatario')}</b>
        <TextField value={record?.receiver_name} />
      </div>
      {record?.receiver_delivery_instructions && (
        <div className="ReceptionShowData">
          <b>{t('Instrucciones para la entrega')}</b>
          <TextField value={record?.receiver_delivery_instructions} />
        </div>
      )}
    </div>
  );
};

export default ReceptionShowReturnAddress;
